import type { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, Text } from '@nxt-costco-com/forge-components';
import { AppActionTypes } from 'src/types';
import { AccordionFormEntry } from 'src/components/CookieSettings/AccordionFormEntry';
import { sectionHeaderPadding } from 'src/constants/styles';
import type { SaleOfInfoAccordionProps } from './types';

export const SaleOfInfoAccordion: FC<SaleOfInfoAccordionProps> = ({ dispatch, state }: SaleOfInfoAccordionProps) => {
    const { t } = useTranslation('translation');
    const locale = state.selectedLanguage;
    let content;

    if (locale === 'en-CA' || locale === 'fr-CA') {
        content = (
            <Text>{t('accordians.saleOfInfo.description')}</Text>
        );
    } else {
        content = (
            <>
                <Text variant='b2'>{t('accordians.saleOfInfo.p1')}</Text>
                <Text variant='b2'>
                    <Trans
                        i18nKey={`accordians.saleOfInfo.p2`}
                        values={{ privacyPolicy: 'Your Privacy Choices' }}
                        components={{
                            1: (
                                <Link href={t('links.dnsmiSrc')} underline="always" color="#3860be">
                                    Privacy Policy
                                </Link>
                            ),
                        }}
                    ></Trans>
                </Text>
                <Text component='h4' variant='t5' bold={true} sx={sectionHeaderPadding}>{t('accordians.saleOfInfo.h3')}</Text>
                <Text variant='b2'>{t('accordians.saleOfInfo.p4')}</Text>
            </>
        );
    }

    return (
        <AccordionFormEntry
            title={t('accordians.saleOfInfo.name')}
            isOptedIn={state.optInPersonalizedAdvertising}
            setOptIn={(value) =>
                dispatch({
                    payload: value,
                    type: AppActionTypes.SET_OPT_IN_PERSONALIZED_ADVERTISING,
                })
            }
            categoryKey="saleOfInfo"
        >
            {content}
        </AccordionFormEntry>
    );
};
